import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    BalanceTotalValues,
    HyperLiquidBalances,
    InitialBalancesState,
    WalletHoldings,
    WSBalancesPayload,
} from './balancesTypes';
import { getBalancesMap } from '@/lib/helpers/helpers';

const initialState: InitialBalancesState = {
    balances: {},
    hyperLiquidBalances: {},
    totalValues: {},
    walletHoldingsChart: {},
    showDustHyperLiquidBalances: false,
};

const slice = createSlice({
    name: 'balances',
    initialState,
    reducers: {
        setShowDustToggle: (state, action: PayloadAction<boolean>) => {
            state.showDustHyperLiquidBalances = action.payload;
        },
        setInitialBalances: (state, action: PayloadAction<WSBalancesPayload>) => {
            const accountId = action.payload.apiKeyId;
            const { balances } = action.payload;
            if (balances?.totalDepostits) {
                delete balances.totalDeposits;
                delete balances.totalWithdrawals;
            }
            if (state?.[accountId]) {
                state.balances[accountId] = {
                    ...state.balances[accountId],
                    ...getBalancesMap(balances),
                };
            } else {
                state.balances = {
                    ...state.balances,
                    [accountId]: { ...getBalancesMap(balances) },
                };
            }
        },
        setTotalValues: (
            state,
            action: PayloadAction<{ accountId: number; values: BalanceTotalValues }>,
        ) => {
            const { accountId, values } = action.payload;
            state.totalValues[accountId] = values;
        },
        setHyperLiquidBalances: (
            state,
            action: PayloadAction<{ accountId: number; values: HyperLiquidBalances[] }>,
        ) => {
            const { accountId, values } = action.payload;
            state.hyperLiquidBalances[accountId] = Array.isArray(values) ? values : [];
        },
        resetBalances: (state) => {
            state.balances = {};
            state.totalValues = {};
            state.walletHoldingsChart = {};
        },
        removeBalancesByAccountId: (state, action: PayloadAction<{ accountId: number }>) => {
            const { accountId } = action.payload;
            if (state.balances?.[accountId]) {
                delete state.balances[accountId];
            }
            if (state.totalValues?.[accountId]) {
                delete state.totalValues[accountId];
            }
        },
        setWalletHoldingsChartByAccountId: (
            state,
            action: PayloadAction<{ apiKey: number; data: WalletHoldings[] }>,
        ) => {
            state.walletHoldingsChart[action.payload.apiKey] = action.payload.data;
        },
    },
});

export const {
    setInitialBalances,
    setTotalValues,
    resetBalances,
    removeBalancesByAccountId,
    setWalletHoldingsChartByAccountId,
    setHyperLiquidBalances,
    setShowDustToggle,
} = slice.actions;
export default slice.reducer;
